import { createAction, createReducer } from '@reduxjs/toolkit';
import type { ProductsListResponse } from 'reactApp/api/billing/products/ProductsAPICall.types';
import { normalizeProducts } from 'reactApp/modules/productsList/productsList.helpers';
import type { ProductsListState } from 'reactApp/modules/productsList/productsList.types';

const INITIAL_STATE: ProductsListState = {
    rawList: {},
    normalizedList: {},
    isLoaded: false,
    isLoading: false,
    hasError: false,
};

export const loadProductsList = createAction<string[]>('productsList/load');
export const setProductsList = createAction<ProductsListResponse>('productsList/setList');
const startLoading = createAction('productsList/startLoading');
const hasError = createAction('productsList/hasError');

export const productsListReducer = createReducer(INITIAL_STATE, {
    [startLoading.type]: (state) => {
        state.isLoading = true;
        state.isLoaded = false;
        state.hasError = false;
    },
    [setProductsList.type]: (state, action: ReturnType<typeof setProductsList>) => {
        state.rawList = {
            ...state.rawList,
            ...action.payload,
        };
        state.normalizedList = {
            ...state.normalizedList,
            ...normalizeProducts(action.payload),
        };
        state.isLoaded = true;
        state.isLoading = false;
    },
    [hasError.type]: () => {
        return {
            ...INITIAL_STATE,
            hasError: true,
        };
    },
});

export const ProductsListActions = {
    loadProductsList,
    setProductsList,
    startLoading,
    hasError,
};
